import apiClient from "../common/apiClient";

export default class DepartmentController {
    async Create(data, token) {
        try {
            return await apiClient.post("/user-medical-mapping", data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Update(departmentId, data, token) {
        try {
            return await apiClient.put("/user-medical-mapping/" + departmentId, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Delete(id, token) {
        try {
            return await apiClient.delete("/user-medical-mapping/" + id, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async GetAllMedicalCentreMapping(token) {
        try {
            return await apiClient.get("/getAllUserMedicalMapping", {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }
}
